export default "__VITE_ASSET__DbxGvDKq__"